import RealEstateCommissionPlansAPI from 'dashboard/api/realEstateCommissionPlans';
import {
  commissionPlanPayload,
  errorMessage,
  formFromPlan,
} from './realEstateCommissionPlanForm';

export function createRealEstateCommissionPlanPersistence({
  editing,
  error,
  form,
  id,
  loading,
  notify,
  plan,
  saving,
  t,
  validate,
}) {
  const load = async () => {
    if (!id.value) return null;
    loading.value = true;
    error.value = '';
    try {
      const response = await RealEstateCommissionPlansAPI.show(id.value);
      plan.value = response.data;
      form.value = formFromPlan(plan.value);
      return plan.value;
    } catch (requestError) {
      error.value = errorMessage(
        requestError,
        t('REAL_ESTATE_COMMISSION_PLAN.ERRORS.LOAD')
      );
      notify(error.value);
      return null;
    } finally {
      loading.value = false;
    }
  };

  const save = async () => {
    if (!id.value || !validate()) return null;
    saving.value = true;
    try {
      const response = await RealEstateCommissionPlansAPI.updateByTransaction(
        id.value,
        commissionPlanPayload(form.value)
      );
      plan.value = response.data;
      form.value = formFromPlan(plan.value);
      editing.value = false;
      notify(t('REAL_ESTATE_COMMISSION_PLAN.ALERTS.SAVED'));
      return plan.value;
    } catch (requestError) {
      error.value = errorMessage(
        requestError,
        t('REAL_ESTATE_COMMISSION_PLAN.ERRORS.SAVE')
      );
      notify(error.value);
      return null;
    } finally {
      saving.value = false;
    }
  };

  return { load, save };
}
